import { ZERO } from "../../../constants";
import { darkModeIcon, lightModeIcon } from "../../../assets/icons";

const ThemeToggler = ({isDarkTheme,handleThemeChange}) => {
 
   return (
    <>
      <div
        role="checkbox"
        aria-checked={isDarkTheme}
        tabIndex={ZERO}
        onClick={handleThemeChange}
        className={`cursor-pointer border-solid border-1 border-gray-400 -z-70 w-14 h-6 rounded-full relative px-1 flex mx-3 items-center${
          isDarkTheme ? " bg-sky-700" : " justify-end bg-sky-500"
        }`}
      >
        <div
          className={`w-5 h-5 rounded-full absolute transform duration-200 ease-out bg-white left-0.5 ${
            isDarkTheme ? "translate-x-8" : "translate-x-0"
          }`}
        />
        <img
          className="h-4 w-4"
          src={isDarkTheme ? lightModeIcon: darkModeIcon }
          alt={isDarkTheme ? "Dark Mode" : "Light mode"}
        />
      </div>
    </>
  );
};

export default ThemeToggler;
